export const ADS_READ_SCOPE = 'ads-read';
export const BLOG_WRITE_SCOPE = 'blog-write';
export const CALENDAR_ACCESS_SCOPE = 'calendar-access';
export const CAMPAIGNS_ACCESS_SCOPE = 'campaigns-access';
export const CAMPAIGNS_WRITE_SCOPE = 'campaigns-write';
export const EMAIL_WRITE_SCOPE = 'email-write';
export const LANDING_PAGES_WRITE_SCOPE = 'landingpages-write';
export const MARKETING_TASKS_WRITE_SCOPE = 'marketing-tasks-write';
export const PAGES_WRITE_SCOPE = 'pages-write';